import ContactButtonGroup from "@components/inputs/ContactButtonGroup";
import { PropsWithClassName } from "kz-ui-sdk";

interface ChatButtonProps extends PropsWithClassName {}

const ChatButton = ({ className }: ChatButtonProps) => {
  return (
    <div className={className}>
      <ContactButtonGroup />
    </div>
  );
};

export default ChatButton;
